import { useMutation } from '@tanstack/react-query';
import { IDetectedBarcode } from '@yudiel/react-qr-scanner';
import { first } from 'lodash';
import { useState } from 'react';
import { useCommonApi } from '../../../api';
import { VehicleResponse } from '../../types/accident';

export const useAccident = () => {
  const [openScanner, setOpenScanner] = useState(false);
  const [orv, setOrv] = useState('');
  const [carData, setCarData] = useState<VehicleResponse | undefined>(undefined);

  const { mutate: fetCarData, isPending: isLoadingCarData } = useMutation(useCommonApi().getCarData());

  const handleScanTP = (data: IDetectedBarcode[]) => {
    setOrv(first(data)?.rawValue ?? '');
    setOpenScanner(false);
  };

  const handleGetCarData = () => {
    fetCarData(
      { orv },
      {
        onSuccess: (data) => setCarData(data.results)
      }
    );
  };

  return {
    openScanner,
    setOpenScanner,
    handleScanTP,
    handleGetCarData,
    setOrv,
    orv,
    carData,
    isLoadingCarData
  };
};
